import script from "./TalentInfoContainer.vue?vue&type=script&lang=ts"
export * from "./TalentInfoContainer.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__